const getters = {
    documentBlocks: state => state.document_blocks,
    documentBlock: state => state.document_block,
    documentTypes: state => state.document_types,
    documentBlockFilters: state => state.document_block_filters,
}

export default getters;
